/**
 * theme.js
 * Utility per la gestione del tema (light/dark)
 */

// Funzione per ottenere il tema corrente
export const getCurrentTheme = () => {
  return localStorage.getItem('theme') || 'light';
};

// Funzione per impostare il tema corrente
export const setCurrentTheme = (theme) => {
  localStorage.setItem('theme', theme);
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};
